module.exports = __webpack_public_path__ + "img/upload-arrow-dark.5e563d73.svg";